/* import __COLOCATED_TEMPLATE__ from './datasets-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ENV from 'bullitttime-uploader/config/environment';

export default class DatasetsCardComponent extends Component
{
	@service store;
	@service uploaderAjax;
	@service errorManager;
	@service confirmation;
	
	@tracked isAddingNew = false;
	@tracked newDatasetName = "";
	@tracked newType = "Custom";
	@tracked newDatasetPath = "";
	@tracked newDatasetPort = "";
	@tracked newDatasetFileName = "";
	@tracked newDatasetPeriod = 60;
	
	@action
	async changeSource(dataset, event)
	{
		try
		{
			const source = await this.store.findRecord('source', event.target.value);
			dataset.set('SourceId', source);
			await dataset.save();
		}
		catch (error)
		{
			dataset.rollbackAttributes();
			// Error is displayed by the adapter
		}
	}
	
	@action
	async changeEnabled(dataset, event)
	{
		try
		{
			if (event.target.checked)
			{
				dataset.set('enabled', true);
				await this.uploaderAjax.request("/datasets/" + dataset.id + "/enable");
			}
			else
			{
				dataset.set('enabled', false);
				await this.uploaderAjax.request("/datasets/" + dataset.id + "/disable");
			}
		}
		catch (error)
		{
			dataset.rollbackAttributes();
			this.errorManager.addError('Failed to change dataset enabled state', { clearable: true, type: 'network' });
		}
	}
	
	@action
	selectEvent(event)
	{
		this.newDatasetPath = "/events/"+event.id+"?simple=true";
		this.newDatasetPort = ENV.eventBackendPort;
		this.newDatasetFileName = "event";
	}
	@action
	async selectEventClassGroups(event)
	{
		await this.store.findRecord('event',event.id,{ reload: true });
		const classGroups = await event.classGroups;
		this.newDatasetPath = "/class-groups?filter[id]=";
		for(const cg of classGroups)
		{
			this.newDatasetPath += (cg.id+",");
		}
		this.newDatasetPath = this.newDatasetPath.replace(/,+$/, "");
		this.newDatasetPort = ENV.eventBackendPort;
		this.newDatasetFileName = "class-groups";
	}
	@action
	selectPenaltiesEvent(event)
	{
		this.newDatasetPath = "/events/"+event.id+"/penalties/individuals";
		this.newDatasetPort = ENV.resultsBackendPort;
		this.newDatasetFileName = "penalties";
	}
	@action
	selectResultsEvent(event)
	{
		this.newDatasetPath = "/events/"+event.id+"/results/individualsSplits";
		this.newDatasetPort = ENV.resultsBackendPort;
		this.newDatasetFileName = "individualResults";
	}
	@action
	selectResultsTeamEvent(event)
	{
		this.newDatasetPath = "/events/"+event.id+"/results/teams";
		this.newDatasetPort = ENV.resultsBackendPort;
		this.newDatasetFileName = "teamResults";
	}
	
	@action
	toggleAddingNew() {
		this.isAddingNew = !this.isAddingNew;
	}

	@action
    changeNewType(event)
	{
		this.newType = event.target.value;
    }
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();

		const newDataset = this.store.createRecord('dataset',
		{
			name: this.newDatasetName,
			path: this.newDatasetPath,
			port: this.newDatasetPort,
			destinationFileName: this.newDatasetFileName,
			period: this.newDatasetPeriod
		});

		try
		{
			await newDataset.save();
			await this.store.findRecord('dataset', newDataset.id);
		}
		catch (error)
		{
			newDataset.rollbackAttributes();
			// Error is displayed by the adapter
			return;
		}

		this.resetNew();
	}
	
	@action cancelNew()
	{
		this.resetNew();
	}
	
	resetNew()
	{
		this.newDatasetName = "";
		this.newType = "Custom";
		
		this.newDatasetPath = "";
		this.newDatasetPort = "";
		this.newDatasetFileName = "";
		this.newDatasetPeriod = 60;
		
		this.isAddingNew = false;
	}
	
	@action
	async deleteDataset(dataset)
	{
		const confirmed = await this.confirmation.confirm({
			title: 'Delete Dataset',
			message: `Are you sure you want to delete the dataset "${dataset.name}"?`,
			confirmLabel: 'Delete',
			confirmStyle: 'danger'
		});
		if (!confirmed)
		{
			return;
		}

		try
		{
			dataset.deleteRecord();
			await dataset.save();
		}
		catch (error)
		{
			dataset.rollbackAttributes();
			// Error is displayed by the adapter
		}
	}
}